"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_ROLE = void 0;
exports.USER_ROLE = {
    ANONYMOUS: 'ANONYMOUS',
    SUPPLIER: 'SUPPLIER',
    STORE_OWNER: 'STORE_OWNER',
    CUSTOMER: 'CUSTOMER',
    SYSTEM_ADMIN: 'SYSTEM_ADMIN',
    CRM_USER: 'CRM_USER',
    WORKSPACE_ADMIN: 'WORKSPACE_ADMIN'
};
//# sourceMappingURL=userRole.js.map